// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cke_combopanel {
    width: auto !important;
    height: auto !important;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
    opacity: 1;
    transform: none;
    transform-origin: center top;
    transition: opacity 266ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 177ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.cke_combo_text {
    min-width: 60px;
    width: auto !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@pixel/internal/Editor/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,iHAAiH;IACjH,UAAU;IACV,eAAe;IACf,4BAA4B;IAC5B,4GAA4G;AAChH;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B","sourcesContent":[".cke_combopanel {\n    width: auto !important;\n    height: auto !important;\n    border-radius: 4px;\n    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);\n    opacity: 1;\n    transform: none;\n    transform-origin: center top;\n    transition: opacity 266ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 177ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.cke_combo_text {\n    min-width: 60px;\n    width: auto !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
